<template>
	<div>
		<a-button
			type="primary"
			class="primary"
			size="small"
			@click="showPackinglist"
		>
			{{ $t('businessDispatch.viewPackingList') }}
		</a-button>
		<a-modal
			:title="$t('businessDispatch.viewPackingList')"
			:visible="visible_showpackinglist"
			@cancel="cancelPackinglist"
			:bodyStyle="bdstyle"
			width="1040px"
		>
			<a-spin :spinning="loading">
				<iframe
					v-if="packingHtml"
					:srcdoc="packingHtml"
					class="packing-iframe"
					frameborder="0"
				></iframe>
			</a-spin>
			<template slot="footer" class="footer_paiche">
				<a-button key="print" :disabled="!packingHtml || loading" @click="printPacking">
					{{ $t('print') }}
				</a-button>
				<a-button key="back" @click="closePackinglist" type="primary">
					{{ $t('close') }}
				</a-button>
			</template>
		</a-modal>
	</div>
</template>

<script>
import { searchReqParam } from "../../utils/searchReqParam";
import { packingListHtml } from "../../api/business-dispatch";
export default {
	name: "packinglist",
	props: {
		selectedRows: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	data() {
		return {
			req: searchReqParam(),
			// 装箱单
			visible_showpackinglist: false,
			bdstyle: {
				height: "750px",
				color: "black",
			},
			// dms生成的装箱单HTML文档
			packingHtml: "",
			loading: false,
		};
	},
	methods: {
		// 装箱单
		showPackinglist() {
			if (this.selectedRows.length >= 1) {
				let params = {};
				// 订单号
				params.orderId = this.selectedRows[0].orderId;
				this.req.params = params;

				this.visible_showpackinglist = true;
				this.loading = true;
				this.packingHtml = "";
				packingListHtml(this.req)
					.then((res) => {
						let result = JSON.parse(res.data);
						if (result.code == "0") {
							// 成功
							this.packingHtml = result.data;
						} else {
							// 失败提示信息
							this.$message.error(result.msg);
						}
						this.loading = false;
					})
					.catch((err) => {
						console.log(err);
						this.loading = false;
					});
			} else {
				this.$message.error(this.$t('businessDispatch.feedbackTransportNode[0]'));
			}
		},
		// 打印装箱单(隐藏iframe,保留颜色,参照f2e-harbour-pc dk-packing-list全部打印)
		printPacking() {
			if (!this.packingHtml) return;
			let iframe = document.createElement('IFRAME')
			iframe.setAttribute(
				'style',
				'position:absolute;width:923px;height:auto;left:-1500px;top:-500px;'
			)
			document.body.appendChild(iframe)
			let doc = iframe.contentWindow.document
			doc.open()
			doc.write('<style media="print">@page {size: auto; margin: 0mm; } html,body{height:auto;}</style>')
			doc.write(this.packingHtml)
			doc.close()
			this.applyPrintLayout(doc, true)
			iframe.contentWindow.focus()
			iframe.contentWindow.print()
			if (navigator.userAgent.indexOf('MSIE') > 0) {
				document.body.removeChild(iframe)
			}
		},
		// 打印排版统一处理,与f2e-harbour-pc dk-packing-list.vue的applyPrintLayout保持一致
		applyPrintLayout(doc, keepColor) {
			let body = doc.body
			if (!body) {
				return
			}
			let printWidth = 923
			let printScale = 0.8
			let landscapePrintScale = 0.75
			let printBodyClass = 'dk-packing-print-body'
			let printColorStyle = keepColor
				? '-webkit-print-color-adjust: exact !important;print-color-adjust: exact !important;'
				: ''
			if (body.classList) {
				body.classList.add(printBodyClass)
			} else if (body.className.indexOf(printBodyClass) === -1) {
				body.className += ' ' + printBodyClass
			}
			let styleDom = doc.createElement('style')
			styleDom.innerText = '@page {size: auto; margin: 0mm; }'
				+ '@media print {'
				+ 'html,body{height:auto !important;min-height:0 !important;overflow:visible !important;}'
				+ 'body.' + printBodyClass + '{'
				+ 'box-sizing:border-box !important;'
				+ 'width:' + printWidth + 'px !important;'
				+ 'margin:0 auto !important;'
				+ 'padding:0 !important;'
				+ 'position:static !important;'
				+ 'left:auto !important;'
				+ 'transform:none !important;'
				+ 'zoom:' + printScale + ' !important;'
				+ 'page-break-after:avoid !important;'
				+ 'break-after:avoid !important;'
				+ printColorStyle
				+ '}'
				+ '}'
				+ '@media print and (orientation: landscape) {'
				+ 'body.' + printBodyClass + '{zoom:' + landscapePrintScale + ' !important;}'
				+ '}'
			if (doc.head) {
				doc.head.appendChild(styleDom)
			}
			body.style.width = printWidth + 'px'
			body.style.margin = '0 auto'
			body.style.padding = '0'
			body.style.position = 'static'
			body.style.left = 'auto'
			body.style.transform = 'none'
			body.style.zoom = printScale
			body.style.overflow = 'visible'
			body.style.pageBreakAfter = 'avoid'
			body.style.breakAfter = 'avoid'
			if (doc.documentElement) {
				doc.documentElement.style.overflow = 'visible'
				doc.documentElement.style.height = 'auto'
				doc.documentElement.style.minHeight = '0'
			}
			if (keepColor) {
				body.style.webkitPrintColorAdjust = 'exact'
				body.style.printColorAdjust = 'exact'
			}
		},
		cancelPackinglist() {
			this.visible_showpackinglist = false;
			this.packingHtml = "";
			this.loading = false;
		},
		closePackinglist() {
			this.visible_showpackinglist = false;
			this.packingHtml = "";
			this.loading = false;
		},
	},
};
</script>

<style lang="less" scoped>
.packing-iframe {
	width: 100%;
	height: 690px;
	border: none;
	background: #fff;
}
</style>
